module.exports = __webpack_public_path__ + "static/media/beauty2.eb6905eb.png";